module.exports = __webpack_public_path__ + "bacee178d2725ede38741707765e4eb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_2.jpg
// module id = 1734
// module chunks = 5